const parseList = (raw) => {
    if (!raw) return [];
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed.map(String);
    } catch (e) {
        // fall through to comma-separated parsing
    }
    return raw
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .map(String);
};

export const ADMIN_IDS = parseList(process.env.REACT_APP_ADMINIDS);
export const BLOCKED_USER_IDS = parseList(process.env.REACT_APP_BLOCKED_USER_IDS);

export const isAdminUserId = (id) => !!id && ADMIN_IDS.includes(String(id));
export const isBlockedUserId = (id) => !!id && BLOCKED_USER_IDS.includes(String(id));
